import RouteGuardService from '~/services/RouteGuardService'
import { Context } from '@nuxt/types'

// routes that are also available to logged in single users
export const singleAllowedRoutes = [
  '__classified_one_click_touch',
  '__classifieds_edit',
  '__classifieds_view',
  '__account_audits_requests_request',
  '__account_audits_requests_certificates_view'
]

// Used per-page when login is required to view the page
export default function({ $dep, route, redirect, app }: Context) {
  const routeGuardService = $dep(RouteGuardService)
  const { router } = app

  const isParkingRoute = Boolean(route.name?.startsWith('__account_parking'))

  let userIsLoggedIn = routeGuardService.userIsLoggedIn()

  if (
    route.name &&
    singleAllowedRoutes.some(r => route.name?.toString().startsWith(r))
  ) {
    userIsLoggedIn =
      routeGuardService.userIsLoggedIn() || routeGuardService.userIsSingle()
  }

  if (!userIsLoggedIn && !isParkingRoute) {
    const resolvedRoute = router?.resolve({
      name: '__login',
      query: { gotonext: route.fullPath, 'must-login': '1' }
    })

    const redirectUrl =
      resolvedRoute?.resolved?.matched?.length && resolvedRoute?.href
        ? resolvedRoute.href
        : `/login/?gotonext=${route.fullPath}&must-login=1`

    return redirect(redirectUrl)
  }
}
